import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebProcessKickoff,
  WebAppProcessPlanning,
  EcommerceWebProcessUIUX,
  CRMDevelopersProcessSupport,
  EcommerceWebProcessQuality,
  WebAppProcessBackend,
} from "../../../../app-constants";
import BgImg from "../../../images/solution/crm-new/crm_process.webp";

function Ecommercewebprocess() {
  return (
    <section
      className="ecommerce_web_process text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our CRM System <span>Development Process</span>
            </h2>
            <p>
              We offer a full Agile development life cycle that encompasses and
              serves your needs, employing the optimal Agile methodologies and
              centering on what the user wants.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  01
                  <h5>Discovery and Strategizing</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessKickoff}
                </div>
              </div>
              <p>
                The consultation starts by identifying your needs and suggesting
                the solutions to implement in your CRM difficulties. According
                to your needs, we determine system requirements, recruit people,
                plan the project, and evaluate possible issues.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  02
                  <h5>Design and Development</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessUIUX}</div>
              </div>
              <p>
                Developers build a CRM system for our company based on the
                description of the design. The objective is to combine existing
                features adapt ready-made features or create the application
                modules from scratch based on your needs.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  03
                  <h5>Integrations</h5>
                </div>
                <div className="ecom_box_icon">{WebAppProcessPlanning}</div>
              </div>
              <p>
                We integrate your CRM solution with existing business workflows
                to ensure seamless data flow and synchronization. Our engineers
                can also incorporate third-party services to enhance the
                system's functionality.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  04
                  <h5>Quality Assurance</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessQuality}
                </div>
              </div>
              <p>
                Our QA team rigorously tests the final product against
                predefined standards, identifying and resolving inefficiencies.
                We perform comprehensive testing to ensure all aspects of your
                software meet high-quality benchmarks.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  05
                  <h5>Data Migration</h5>
                </div>
                <div className="ecom_box_icon">{WebAppProcessBackend}</div>
              </div>
              <p>
                We transfer essential data from legacy systems and spreadsheets
                to provide a complete and accurate picture. Our developers
                devise a migration strategy to prevent data loss and minimize
                disruption to your business operations.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  06
                  <h5>Support</h5>
                </div>
                <div className="ecom_box_icon">
                  {CRMDevelopersProcessSupport}
                </div>
              </div>
              <p>
                Post-deployment, our team provides ongoing support, including
                regular updates, performance optimization, and security patches.
                We also fine-tune the solution to ensure it continues to meet
                your company's evolving needs.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercewebprocess;
